import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-user-edit'
})
export class Ng1UserEditDirective extends UpgradeComponent {
  @Input() user;
  @Input() userStats;
  @Input() userIndex;
  @Input() state;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('usersEdit', elementRef, injector);
  }
}
